import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { getFullUrl } from 'hubspot-url-utils';
import Raven from 'raven-js';
import { getIsQAProxy } from '../utils/proxyUtils';
const PUBLIC_ENDPOINT = 'monetization/v3/product/bundle/public';
export const getPublicProductBundles = apiNames => {
  const countryCode = window.COUNTRY_CODE_FROM_LOCALE && window.COUNTRY_CODE_FROM_LOCALE.toUpperCase();
  const url = `${getFullUrl('app-api', getIsQAProxy() ? {
    envOverride: 'qa'
  } : {})}/${PUBLIC_ENDPOINT}?countryCode=${countryCode}`;
  return noAuthHttp.get(url, {
    query: {
      productApiNames: apiNames
    }
  }).catch(err => {
    Raven.captureException(err, {
      fingerprint: ['Failed to fetch public product bundles'],
      extra: {
        apiNames
      }
    });
    throw err;
  });
};